// @flow

import React, { Component } from "react"
import { connect } from "react-redux"
import style from "./style.css"
import BigList from "../../components/BigList"
import Dialog from "react-toolbox/lib/dialog"
import Division from "../../components/Division"
import { getLogs } from "../../actions"
import _ from "lodash"
import * as strings from "../../strings"
import JSONPretty from "react-json-pretty"
import { toastr } from "react-redux-toastr"

class ManageLogs extends Component {

  constructor ( props ) {
    super( props )
    this.state = {
      dialog: {
        action: "",
        detail: "",
        active: false,
      },
      active: false,
      data: [],
    }
  }

  props: {
    history: any,
    auth: any,
  }

  handleToggle = ( id ) => () => {
    if ( !id ) {
      this.setState( {
        dialog: { active: false },
      } )
      return
    }
    const row = _.find( this.state.data, ( row ) => row.id === id )

    this.setState( {
      dialog: {
        active: true,
        action: row.title,
        detail: row.message,
      },
    } )
  }

  componentDidMount () {
    getLogs( this.props.auth.token ).then( ( response ) => {

      const processed = response.result.map( ( row ) => {
        return {
          ...row,
          _onClick: this.handleToggle( row.id ),
        }
      } )
      this.setState( {
        data: processed,
      } )
    } ).catch( () => {
      toastr.error( strings.generalStrings.errorDownloading )
    } )
  }

  render () {

    const USER_COLUMNS = [
      { title: strings.generalStrings.name, key: "user" },
      { title: strings.generalStrings.action, key: "title" },
      { title: strings.generalStrings.date, key: "date" },
    ]

    return (
      <div>
        <Dialog
          actions={ [ { label: "OK", onClick: this.handleToggle() } ] }
          active={this.state.dialog.active}
          onEscKeyDown={this.handleToggle()}
          onOverlayClick={this.handleToggle()}
          className={style.dialogBox}
        >
          <div className={style.dialogContainer}>

            <div className={style.blueBar} />

            <Division title={strings.generalStrings.action}/>
            <div className={style.wrapper} >
              <div>
                <p>{this.state.dialog.action}</p>
              </div>
            </div>
            <Division title={strings.generalStrings.details}/>
            <div className={style.wrapper} >
              <div>
                <JSONPretty json={this.state.dialog.detail} space="4" />
              </div>
            </div>
          </div>
        </Dialog>
        <BigList
          loadMore={() => {}}
          hasMoreItems={ () => false }
          items={ this.state.data }
          columns={USER_COLUMNS}
        />
      </div>
    )
  }
}

const mapStateToProps = ( state ) => {
  return {
    auth: state.auth,
  }
}

export default connect( mapStateToProps, { getLogs } )( ManageLogs )



// WEBPACK FOOTER //
// ./src/views/ManageLogs/index.jsx